export const DEFAULT_SECURITY_QUESTION = 'Please enter the answer I sent you.';

export const OTHER_SECURITY_QUESTION_OPTION = 'Other';

export const INTERAC_SECURITY_QUESTIONS = [
  DEFAULT_SECURITY_QUESTION,
  'What city is the property in?',
  'What street is the property on?',
  'What is the unit number?',
  'What floor is the unit on?',
  'What is the building name?',
  'What is the parking spot?',
  'What is the locker number?',
  'What is the buzzer number?',
  'What month does the lease start?',
  OTHER_SECURITY_QUESTION_OPTION,
] as const;

export type InteracSecurityQuestionOption = (typeof INTERAC_SECURITY_QUESTIONS)[number];

export function resolveSecurityQuestionOption(question: string): InteracSecurityQuestionOption {
  const match = INTERAC_SECURITY_QUESTIONS.find(
    (option) => option !== OTHER_SECURITY_QUESTION_OPTION && option === question
  );
  return match ?? OTHER_SECURITY_QUESTION_OPTION;
}
